import React from 'react';
import { useState, useRef, useLayoutEffect } from "react";
import blobPath from './MyMapUtils/blobPath';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import LoopIcon from '@mui/icons-material/Loop';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import GetApplicationInfoData from './MyMapUtils/GetApplicationInfo';
const ManagementStatus = window.SIMPL.ManagementStatus;

export default function ActiveDataPanelTrafficRegulation(props) {
    const memoRef = useRef(null);
    const applicationStatusRef = useRef(null);
    const notificationDateRef = useRef(null);
    const ActiveDataPanelRef = useRef(null);
    const [infoAreaHeight, setInfoAreaHeight] = useState(0);
    const [accordionHeight, setAccordionHeight] = useState(0);
    
    //編集内容のクリア+編集モード解除
    function onClear(){
        props.editClear(true);
    }
    
    useLayoutEffect(() => {
        // 管理パネルの高さを再計算
        if (ActiveDataPanelRef.current) {
            let margin = 20*2;  //上下のマージン分
            let workArea = 40;
            let photoArea = 196;
            let titleArea = 41 + 5;
            let gap = 10*2;
            var size = ActiveDataPanelRef.current.clientHeight;
            setInfoAreaHeight(
                size - margin - photoArea - gap - workArea +'px'
            );
            setAccordionHeight(
                size - margin - photoArea - gap - workArea - titleArea +'px'
            );
        }
    }, [props.height]); //ウィンドウ高さが変わったとき

    return (
        <div className={"ActiveDataPanel ActiveDataPanelTrafficRegulation"} ref={ActiveDataPanelRef}>
            <div className='ActiveDataItem'>
                <div className='ActiveDataItem-workArea'>
                    <Button className='ActiveDataItem-button' title={"キャンセル"}
                        onClick={()=>onClear()}
                        variant="text"
                        disabled={props.isUpdate}
                        size="small"
                        sx={{width:"40px",minWidth:"40px",height:"40px",padding:"0",color:"#444444"}}
                        >
                        <ArrowBackIcon fontSize="large" />
                    </Button>
                    <div style={{display:"flex",gap:"10px",flexDirection:"row"}}>
                    <Button className='ActiveDataItem-button' title={"通知書を発行する"}
                        onClick={()=> window.open(window.location.origin + '/Notification/' + props.selectedItem?.id)}
                        variant="contained"
                        disabled={props.isEditMode}
                        size="small"
                        >
                        <InsertDriveFileIcon/>
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集する"}
                        onClick={props.setIsEditMode}
                        variant="contained"
                        sx={props.isEditMode ?{display:"none"}:{}}
                        size="small"
                        >
                        <ModeEditIcon/>
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集を保存"}
                        onClick={()=>props.updateData(props.selectedItem,applicationStatusRef.current.value,notificationDateRef.current.value,memoRef.current.value)}
                        variant="contained"
                        sx={!props.isEditMode ?{display:"none"}:{}}
                        disabled={props.isUpdate}
                        size="small"
                        id="saveButton"
                        >
                        {!props.isUpdate ? <SaveIcon /> :<LoopIcon className="loop_Icon"/>}
                    </Button>
                    </div>
                </div>
                <div className="ActiveDataItem-photoArea">
                    {props.selectedItem?.PhotoURL === null ?
                        <div className='ActiveDataItem-NoImage'>No Image</div>
                    :
                        <a href={blobPath(props.selectedItem?.PhotoURL)} target="_blank" rel="noopener noreferrer">
                            <img decoding="async" className="ActiveDataItem-photo2 sr-item-img "
                                src={props.selectedItem !== null ?blobPath(props.selectedItem.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL): null}
                                aria-hidden="true" alt="" target="_blank"
                                onMouseEnter={(e) => props.onEnterImg(e, (props.selectedItem?.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL)) }    
                                onMouseLeave={(e) => props.onLeaveImg(e, (props.selectedItem?.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL)) }
                            />
                        </a>
                    }
                </div>
                <div style={{height:"100%",width:"100%",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <div className={'ActiveDataItem-infoArea' + (props.isEditMode? " ActiveDataItem-infoArea-edit" : "")} style={{ height: infoAreaHeight}}>
                        
                    {/* タイトル */}
                    <div style={{marginBottom:"5px",display:"flex",justifyContent:"space-between",borderBottom:"1px solid gray"}}>
                        <a href={window.location.origin + '/Detail/Details/' + props.selectedItem?.id}
                            className={"ActiveDataItem-infoArea-title"} style={{minHeight:"30px",margin:"0"}} target="_blank" rel="noopener noreferrer">
                            {props.selectedItem?.title}
                        </a>
                    </div>
                    
                    <div className="accordion" style={{ height: accordionHeight}}>
                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ManagementInfo">
                                    <label>管理情報</label>
                                </button>
                            </div>
                            <div id="ManagementInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <div style={{display: "flex",alignItems:"center"}}>
                                                <label className="ActiveDataItem-infoArea-title" style={{height:"24px"}}>地図上の位置情報</label>
                                            </div>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>緯度：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.startLat}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>経度：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.startLng}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>申請の状態</label>
                                            {props.isEditMode ?
                                                <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                    <select style={{height:'30px',width:"100%"}}
                                                        defaultValue={props.selectedItem?.applicationStatus}
                                                        ref={applicationStatusRef}
                                                        onChange={()=>{
                                                            if(props.selectedItem?.applicationStatus !== applicationStatusRef.current.value){
                                                                props.setIsEdit(true);
                                                            }
                                                        }}
                                                        disabled={props.isUpdate}>
                                                            {ManagementStatus["applicationStatus"].map((data,index)=><option value={data.no} key={index}>{data.name}</option>)}
                                                    </select>
                                                </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{GetManagementStatus("applicationStatus",props.selectedItem?.applicationStatus,"name")}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                        <label className={"ActiveDataItem-infoArea-title"}>メモ[内部用]</label>
                                            {props.isEditMode ?
                                                    <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                        <textarea  id='memo' type="text" style={{width: "100%",height:"70px",resize:"vertical"}}
                                                            defaultValue={props.selectedItem !== null ? props.selectedItem.memo : null}
                                                            ref={memoRef}
                                                            disabled={props.isUpdate}
                                                            onBlur={()=>{
                                                                var text = memoRef.current.value;
                                                                var new_text = text.replace(/\n/g, "");
                                                                if (new_text !== text) {
                                                                    // 元の値と置き換えた値が等しくなければ新しい値に置き換える
                                                                    memoRef.current.value = new_text;
                                                                }
                                                                if(props.selectedItem?.memo !== memoRef.current.value){
                                                                    props.setIsEdit(true);
                                                                }
                                                            }}/>
                                                    </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.memo}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>通知日</label>
                                            {props.isEditMode ?
                                                <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                    <input type="date"
                                                        style={{height:'30px',width:"150px",padding:"5px",borderWidth:"1px",borderRadius:"3px"}}
                                                        defaultValue={props.selectedItem?.notificationDate}
                                                        ref={notificationDateRef}
                                                        onChange={(e)=>{
                                                            if(props.selectedItem?.notificationDate !== notificationDateRef.current.value){
                                                                props.setIsEdit(true);
                                                            }
                                                        }}
                                                        disabled={props.isUpdate}
                                                    />
                                                </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.notificationDate}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>更新情報</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>最終更新日時：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.modifiedDateTime}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>更新者：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.modifiedBy}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ApplicationInfo">
                                    <label>申請情報</label>
                                </button>
                            </div>
                            <div id="ApplicationInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>申請日</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.applicationDate}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>路線名</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.Roadtitle}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>地内</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.restrictedPlace}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>制限種別</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item'>{GetApplicationInfoData("restrictedType",props.selectedItem?.restrictedType,"name")}</label>
                                                </div>
                                                {props.selectedItem?.restrictedType === "7" && 
                                                    <div className='ActiveDataItem-infoArea-item-group'>
                                                        <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.restrictedTypeOther}</label>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>時間帯</label>
                                            <label className='ActiveDataItem-infoArea-item'>{GetApplicationInfoData("restrictedTimeZone",props.selectedItem?.restrictedTimeZone,"name")}</label>

                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>道路延長</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.length}m</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>道路幅員</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.width}m</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>規制期間</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>開始：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.restrictedStartDateTime}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>終了：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.restrictedEndDateTime}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>日数：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.restrictedDays}日間</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>迂回路</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.detourRoute ? "あり" : "なし"}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>工事名</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.projectName}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>申請内容</label>
                                            <label className='ActiveDataItem-infoArea-item'>{GetApplicationInfoData("ApplicationContents",props.selectedItem?.ApplicationContents,"name")}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>その他事項</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.ApplicationContentsOther}</label>     
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>備考</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.remarks}</label>     
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#FileList">
                                    <label>関連資料</label>
                                </button>
                            </div>
                            <div id="FileList" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        {/* 動的（.map）での構成の場合エラーが発生する為、暫定ハードで呼び出し */}
                                        {props.selectedItem?.files.length > 0 &&
                                            <a href={blobPath(props.selectedItem?.files[0].path)} className={"ActiveDataItem-infoArea-title"} target="_blank" rel="noopener noreferrer">
                                            {props.selectedItem?.files[0].fileName}
                                        </a>}
                                        {props.selectedItem?.files.length > 1 &&
                                            <a href={blobPath(props.selectedItem?.files[1].path)} className={"ActiveDataItem-infoArea-title"} target="_blank" rel="noopener noreferrer">
                                            {props.selectedItem?.files[1].fileName}
                                        </a>}
                                        {props.selectedItem?.files.length > 2 &&
                                            <a href={blobPath(props.selectedItem?.files[2].path)} className={"ActiveDataItem-infoArea-title"} target="_blank" rel="noopener noreferrer">
                                            {props.selectedItem?.files[2].fileName}
                                        </a>}
                                        {props.selectedItem?.files.length > 4 &&
                                            <label className='ActiveDataItem-infoArea-item'>...他{props.selectedItem?.files.length - 3}件</label>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ApplicantInfo">
                                    <label>申請者情報</label>
                                </button>
                            </div>
                            <div id="ApplicantInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>発注者</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.Orderer}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>担当者：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.OrdererName}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>電話番号：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.OrdererPhoneNumber}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>受注者</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.Contractor}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>担当者：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.ContractorName}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>電話番号：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.ContractorPhoneNumber}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}